import { Button, Typography } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'

import { tabs } from '../../utils/config'

const descriptions = {
  [tabs.custodialWallets]: {
    title: 'The Best Cryptocurrency Wallets',
    subtitle:
      'Custodial wallets hold crypto funds on behalf of their clients. They are equivalent to a bank account in the crypto world.',
  },
  [tabs.nonCustodialWallets]: {
    title: 'The Best Non-custodial Crypto Wallets',
    subtitle:
      'Non-custodial wallets put users in control of their funds. The wallet provider has no means of accessing or freezing users funds.',
  },
  [tabs.hardwareWallets]: {
    title: 'The Best Hardware Wallets',
    subtitle:
      'Hardware wallets are specialized physical devices that safely store private keys and the associated cryptocurrencies of users.',
  },
  [tabs.p2p]: {
    title: 'The Best Peer-To-Peer Exchanges',
    subtitle:
      'Peer-to-peer exchanges are marketplaces where people can trade crypto directly with each other.',
  },
  [tabs.savingAccounts]: {
    title: 'The Best Crypto Savings Accounts',
    subtitle:
      'Earn interest on your crypto by depositing your assets into a crypto savings account',
  },
  [tabs.exchanges]: {
    title: 'The Best Crypto Exchanges',
    subtitle:
      'Crypto Exchanges allow you to buy at the best market rate cryptocurrency using conventional payment methods like by bank transfer or credit card.',
  },
  [tabs.cryptoCards]: {
    title: 'The Best Crypto Cards',
    subtitle:
      'Spend your cryptocurrency in stores or online using a conventional payment card. You won’t need a bank account anymore.',
  },
  [tabs.decentralizedExchanges]: {
    title: 'The Best Decentralized Exchanges',
    subtitle:
      'Decentralized Exchanges allow you to trade assets without having to go through a middleman. Trades happen on the Blockchain and are free from regulation.',
  },
  [tabs.howToChooseCryptoWallet]: {
    title: 'How to choose a crypto wallet',
    subtitle:
      'Finding the right cryptocurrency wallet is no easy task. But if you want to use your crypto on an everyday basis it is crucial that you understand the different models that exist and choose a wallet that suits your needs.',
  },
  [tabs.bitcoinWallets]: {
    title: 'Best Bitcoin Wallets',
    subtitle:
      'Bitcoin Wallets are optimized for storing and sending bitcoin. In some cases they also offer Lightning support - a solution for sending bitcoin instantly with almost no fees.',
  },
  [tabs.ethereumWallets]: {
    title: 'Best Ethereum Wallets',
    subtitle:
      'Ethereum wallets let you receive send & store tokens on the Ethereum network as well as connect and use decentralized applications (dapps).',
  },
  [tabs.defi]: {
    title: 'The Best DeFi Lending Rates',
    subtitle: 'Earn interest on your crypto by depositing your assets into a DeFi protocol',
  },
  [tabs.buyBitcoin]: {
    title: 'Choosing the Best Bitcoin exchange',
    subtitle:
      'New users interested in bitcoin or other cryptocurrencies often struggle with figuring out how to buy their first bitcoins, but it isn’t as difficult as people make it seem. The actual buying process is quite simple, you just need to figure out a reliable solution that fits your personal situation.',
  },
  [tabs.deals]: {
    title: 'The Best Deals in Crypto',
    subtitle:
      'Take advantage of our exclusive deals with some of the best companies in the crypto space.',
  },
  [tabs.ethereumStaking]: {
    title: 'The Best Ethereum Staking Platforms',
    subtitle: 'Earn yield on your Ether by depositing it on an Ethereum staking platform',
  },
  [tabs.tokens]: {
    title: 'Best DeFi Tokens',
    subtitle:
      'Learn about the world of decentralized finance and go through our curated list of deep dives on the best DeFi projects in the space.',
  },
}

const useStyles = makeStyles((theme: Theme) => ({
  descriptionContainer: {
    margin: '30px 0',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '20px',
      width: '95%',
    },
  },
  descriptionTitle: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    marginBottom: '10px',
    fontSize: '28px',
    fontFamily: 'Space Grotesk',
    lineHeight: '1.5em',
    [theme.breakpoints.down('xs')]: {
      fontSize: '28px',
      marginBottom: '0',
    },
  },
  descriptionSubtitle: {
    color: 'white',
    '@media (max-width: 420px)': {
      display: 'none',
    },
    fontSize: '20px',
    lineHeight: '32px',
    fontFamily: 'Inter',
  },
  readMore: {},
  learnButton: {
    border: `1px solid ${theme.palette.secondary.main}`,
    padding: '10px',
    marginTop: '30px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '20px',
    },
  },
  learnText: {
    color: theme.palette.secondary.main,
    fontSize: '18px',
    textTransform: 'none',
    fontWeight: 'normal',
  },
}))

function Description({
  selectedTab,
  title,
  description,
}: {
  selectedTab?: string
  title?: string
  description?: string
}): JSX.Element {
  const classes = useStyles({})
  return (
    <div className={classes.descriptionContainer}>
      <Typography variant="h1" className={classes.descriptionTitle}>
        {selectedTab ? descriptions[selectedTab]?.title : title}
      </Typography>
      <Typography variant="body2" className={classes.descriptionSubtitle}>
        {selectedTab ? descriptions[selectedTab]?.subtitle : description}
      </Typography>
      <Button href="#read_more" className={classes.learnButton}>
        <Typography variant="subtitle1" className={classes.learnText}>
          Learn more
        </Typography>
      </Button>
    </div>
  )
}

export default Description
